module.exports = __webpack_public_path__ + "static/media/cpIcon1.dabf5066.svg";